import { Container, Row, Col, Image } from 'react-bootstrap'
import Link from 'next/link'
import { Request } from '@group-devs/yfp7-global-modules'
const request = new Request(process.env.apiDomain)

const ConfirmHeader = (props) => {

    const url = process.env.backofficeDomain;

    const accountId = props.props.site.accountId;
    const { data: profile  } = request.account.swrAccountProfile(accountId)
    const user_id = profile ? parseInt(profile.user.id) : '';
    const urlWyd = 'https://'+props.props.site.url

    return (
    <>
        <div className="section-confirmation-header">
            <Container>
                <h1>THANKS FOR REQUESTING MY FREE REPORT!</h1>
                <Row>
                    <Col md={7}>
                        <div className="input-group download-the-ebook">
                            <span className="input-group-addon" id="basic-addon1">
                                <Link href={url + "website/ebook/wyd?user_id="+user_id+"&download=true"} passHref><a>
                                    <Image src="../images/7bs/img-7bs-download01.png" alt="Download"/>
                                </a></Link>
                            </span>
                            <div className="form-control">
                                <p>
                                    <a href={url + "website/ebook/wyd?user_id="+user_id+"&download=true"} className="">DOWNLOAD THE E-BOOK
                                </a></p>
                            </div>
                        </div>
                        <div className="input-group share-this">
                            <span className="input-group-addon" id="basic-addon1">
                                <Image src="../images/wyd/img-wyd-share01.png" alt="Share"/>
                            </span>
                            <div className="form-control"><p>SHARE THIS</p></div>
                        </div>
                        <div className="form-control share-icons">
                            <span className="facebook-icon"><Link href={"https://www.facebook.com/sharer/sharer.php?u="+urlWyd} passHref><a target="_blank"><Image src="../images/wyd/img-wyd-facebook01.png"/></a></Link></span>
                            <span className="twitter-icon"><Link href={"https://twitter.com/intent/tweet?url="+urlWyd+"&text=What Your Doctor Wasn't taught in Med School %0A"} passHref><a target="_blank"><Image src="../images/wyd/img-wyd-twitter01.png"/></a></Link></span>
                        </div>
                    </Col>
                    <Col md={5}>
                        <Image src="../images/wyd/img-ebook-doctor10.png" alt="Download Ebook" className="img-fluid d-block w-auto mx-auto ebook mt-md-0 mt-3"/>
                    </Col>
                </Row>
            </Container>
        </div>
        <style jsx global>{`

            .section-confirmation-header {
                background: #e5e7e7;
                padding-top: 60px;
                padding-bottom: 200px;
            }

            .section-confirmation-header .container {
                background: url(../images/wyd/bg-confirmation-header01.jpg) no-repeat top center;
                background-size: cover;
                padding: 20px 30px 0px;
            }

            .section-confirmation-header h1 {
                font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                font-size: 62px;
                margin-bottom: 0px;
            }

            .section-confirmation-header .download-the-ebook {    
                margin-top: 60px;
                margin-bottom: 20px;
                font-size: 18px;
                line-height: 30px;
            }

            .section-confirmation-header .download-the-ebook .input-group-addon {    
                background-color: #fdd051;
                color: #000;
                padding: 15px;
            }

            .section-confirmation-header .download-the-ebook .form-control {    
                padding: 29px;
                font-size: 15px;
                max-width: 298px;
                background: #00aec7;
                color: #fff;
            }

            .section-confirmation-header .download-the-ebook .form-control p {    
                margin-top: -13px;
                font-size: 20px;
            }

            .section-confirmation-header .download-the-ebook .form-control a {    
                color:#fff !important;
                text-decoration: none;
            }

            .section-confirmation-header .share-icons{    
                margin-top: -27px;
                max-width: 244px;
                padding-bottom: 45px;
                padding-top: 15px;
                padding-left: 30px;
            }

            .section-confirmation-header .share-icons a{    
                color: #fff !important;
            }

            .section-confirmation-header .share-icons .facebook-icon,
            .section-confirmation-header .share-icons .twitter-icon{    
                padding-right: 30px;
            }

            .section-confirmation-header .share-this {
                margin-bottom: 20px;
                font-size: 18px;
                line-height: 30px;
            }

            .section-confirmation-header .share-this .input-group-addon {
                background-color: #fdd051;
                color: #000;
                padding: 15px;
            }

            .section-confirmation-header .share-this .form-control {
                padding: 31px;
                font-size: 15px;
                max-width: 185px;
                background: #00aec7;
                color: #fff;
            }

            .section-confirmation-header .share-this .form-control p {    
                margin-top: -13px;
                font-size: 20px;
            }

            @media (max-width: 767.98px) {	

                .section-confirmation-header h1 {
                    font-size: 42px;
                    margin-bottom: 0px;
                }
	
            }

        `}</style>
    </>
    )
}

export default ConfirmHeader;